import { render, staticRenderFns } from "./seekHelpDrafts.vue?vue&type=template&id=60d2f454&scoped=true"
import script from "./seekHelpDrafts.vue?vue&type=script&lang=js"
export * from "./seekHelpDrafts.vue?vue&type=script&lang=js"
import style0 from "./seekHelpDrafts.vue?vue&type=style&index=0&id=60d2f454&prod&lang=css"
import style1 from "./seekHelpDrafts.vue?vue&type=style&index=1&id=60d2f454&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d2f454",
  null
  
)

export default component.exports